import { useState, useEffect } from 'react'
import { LocationService } from '../../../services/LocationService'
import { fetchHelper } from '@ace/react-utilities'

const Header = (props) => {
  return (
    <header className="widget__head">
      <h3 className="widget__title widget__title--other-pros">{props.title}</h3>
    </header>
  )
}

const AcePro = (props) => {
  return (
    <article className="widget__ace-pro">
      <a className="widget__ace-pro-wrap" href={props.ProfileURL}>
        <div className={"widget__ace-pro-thumbnail-outer"}>
          <div className="widget__ace-pro-thumbnail">
            <img src={props.ProfileImageURL} alt={props.FullName} />
          </div>
        </div>
        <div className="widget__ace-pro-caption">
          <h4 className="widget__ace-pro-name">{props.FullName}</h4>
          <span className="widget__ace-pro-location">{props.City}, {props.StateCode} </span>
        </div>
      </a>
    </article>
  )
}

const AceProList = (props) => {
  return (
    <div className="widget__ace-pros">
      {props.aceProModelList.map(pro => <AcePro {...pro} />)}
    </div>
  )
}

const FindAnAcePro = (props) => {
  const [aceProModelList, setAceProModelList] = useState([])


  const findAPro = (zipCode) => {
    const url = "/webservices/FindACEPro.svc/GetACEPros";
    const aceProViewModel = {
      zipCode: zipCode,
      returnCoun: props.returnCount || 3
    }

    const options = {
      method: 'POST',
      body: JSON.stringify(aceProViewModel),
    }

    fetchHelper(url, options)
      .then((response) => response.json())
      .then((data) => {
        setAceProModelList(data)
      })
      .catch(error => console.error(error.message))
  }

  useEffect(() => {
    LocationService().then((data) => {
      findAPro(data.zipCode)
    })
  }, [])


  if (aceProModelList.length > 0) {
    return <section className='widget'>
      <Header title={props.title} />
      <AceProList aceProModelList={aceProModelList} />
    </section>
  }

  return null
}

export default FindAnAcePro